require('./filter-card-editor-cell.component.scss');

export class FilterCardEditorCellController {
  constructor($scope, $element) {
    this.$scope = $scope;
    this.$element = $element;
  }

  $onInit() {
  }

  $onDestroy() {
  }

  getHeight() {
    if (!this.filter || !this.filter.cardHeight) {
      return 'auto';
    }
    const marginHorz = 0.5; // percent
    const marginVert = 7; // px
    return (this.$element.parent().width() * 0.01 *
      this.filter.cardHeight * (100 - 13 * marginHorz) / 12 +
      marginVert * 2 * (this.filter.cardHeight - 1)).toFixed(0) + 'px';
  }
}

export const FilterCardEditorCellComponent = {
  bindings  : {
    filter    : '<',
  },
  template  : require('./filter-card-editor-cell.component.html'),
  controller: FilterCardEditorCellController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/filter-card-editor-cell.component.js